<template>
  <div></div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({      
      env: "env"
    }),
  },
  mounted() {
    this.setFavicon();
  },
  methods: {    
    setFavicon(){
      const faviconUrl = this.env.get('VUE_APP_TAB_LOGO');
      const link = document.querySelector("link[rel~='icon']");
      if (link) {
        link.href = faviconUrl;
      } else {
        const newLink = document.createElement("link");
        newLink.rel = "icon";
        newLink.href = faviconUrl;
        document.head.appendChild(newLink);
      }
    }
  },
};
</script>
